import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut } from "lucide-react";

// Layout dedicato al portale responsabile: nessun menu del gestionale interno.
export const ResponsabileLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = async () => { await logout(); navigate("/login"); };
  return (
    <div className="min-h-screen grid-bg text-slate-200">
      <header className="sticky top-0 z-40 glass border-b border-slate-700/60">
        <div className="max-w-3xl mx-auto px-4 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <img src="/logo.png" alt="Gigli Edition" className="h-9 w-auto" />
            <div className="leading-tight border-l border-slate-700/60 pl-2.5">
              <div className="text-[10px] uppercase tracking-widest text-amber-300/80">Le mie raccolte</div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-xs text-slate-400 hidden sm:inline" data-testid="resp-username-label">{user?.username}</span>
            <button data-testid="resp-logout-btn" onClick={handleLogout} className="flex items-center gap-1.5 text-sm text-slate-300 hover:text-red-400 px-2 py-1.5 rounded-md hover:bg-red-500/10"><LogOut className="w-4 h-4" /> <span className="hidden sm:inline">Esci</span></button>
          </div>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-6 fade-in">{children}</main>
    </div>
  );
};
